import { z } from 'zod';
import { baseDocumentFields, moneyCents, objectIdString } from './common.js';
import { saleStatus } from './enums.js';

export const sale = z
  .object({
    ...baseDocumentFields,
    leadId: objectIdString,
    brokerId: objectIdString,
    propertyId: objectIdString.optional(),
    unitNumber: z.string().trim().max(40).optional(),
    contractValueCents: moneyCents,
    commissionValueCents: moneyCents.optional(),
    platformFeeValueCents: moneyCents.optional(),
    status: saleStatus,
    cancellationReason: z.string().max(500).optional(),
    contractDate: z.coerce.date(),
    /** Firebase UID of the user who marked the sale (broker or admin). */
    markedByFirebaseUid: z.string().min(1),
  })
  .strict();

export type Sale = z.infer<typeof sale>;
